import React from "ES/lib/react";


/**
 * This version of the ModalWrap does not animate, which makes it more tolerant of bad HTML
 * elsewhere on the page (as when messages are showing, which may contain wild HTML tags).
 *
 */
export default React.createClass({
  propTypes: {
    body: React.PropTypes.node
  },

  componentWillMount: function () {
  },


  render: function (props) {
    const body = this.props.body;

    const animate_classes = "fade in";
    const display = "block";

    return (
      <div>
        <div
          className={"modal " + animate_classes}
          tabIndex={-1}
          role="dialog"
          style={{display: display}}
        >
          {body}
        </div>
        <div
          className={"modal-backdrop " + animate_classes}
          style={{display: display}}
        />
      </div>
    );
  }
});


// WEBPACK FOOTER //
// ./src/components/widgets/ModalWrap.js